import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../services/Api";
import { AuthContext } from "./AuthContext";

export const BadgesContext = createContext({ auctions: 0, favorites: 0 });

export const useBadges = () => useContext(BadgesContext);

export const BadgesProvider = ({ children }) => {
    const { isAuthenticated } = useContext(AuthContext);
    const [badges, setBadges] = useState({ auctions: 0, favorites: 0 });

    useEffect(() => {
        let intervalId;

        const fetchBadges = async () => {
            try {
                const resp = await api.getBadges();
                const auctions = Number(resp?.auctions ?? 0);
                const favorites = Number(resp?.favorites ?? 0);
                if (!Number.isFinite(auctions) || !Number.isFinite(favorites)) return;
                setBadges((prev) =>
                    prev.auctions !== auctions || prev.favorites !== favorites
                        ? { auctions, favorites }
                        : prev
                );
            } catch (e) {
                // ignore errors
            }
        };

        if (isAuthenticated) {
            fetchBadges();
            intervalId = setInterval(fetchBadges, 10000);
        } else {
            setBadges({ auctions: 0, favorites: 0 });
        }

        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [isAuthenticated]);

    return <BadgesContext.Provider value={badges}>{children}</BadgesContext.Provider>;
};
